import React, { useState, useEffect, useRef } from "react";
import * as XLSX from 'xlsx';
import axios from 'axios';
import { Accordion } from "semantic-ui-react";
import { Icon, Input, Button, Dropdown, Grid, Popup, Segment, Tab, Table, Menu, Form, TextArea, Label, Header, Checkbox } from 'semantic-ui-react';
import { SheetDatanew } from '../../../services/auth-service/authService'

import Select, { components } from "react-select";
import { render } from "@testing-library/react";
// import Modal from 'react-modal';
import Modal from 'react-bootstrap/Modal';

import {GetProcessNames, SaveRelationship} from '../../../services/process/process_data/process_data';

import './relationship.css';


const identifier = [
  { value: "string", label: "string" },
  { value: "int", label: "int" },
  { value: "special charectors", label: "special charectors" },
  { value: "contains", label: "contains" },
  { value: "starts with", label: "starts with" },
  { value: "ends with", label: "ends with" },

];

const identifier1 = [
  { value: "2way", label: "2way" },
  { value: "3way", label: "3way" },
  { value: "multi way", label: "multi way" },

];


const ValueContainer = ({ children, getValue, ...props }) => {
  let maxToShow = 1;
  var length = getValue().length;
  let displayChips = React.Children.toArray(children).slice(0, maxToShow);
  let shouldBadgeShow = length > maxToShow;
  let displayLength = length - maxToShow;

  return (
    <components.ValueContainer {...props}>
      {!props.selectProps.inputValue && displayChips}
      <div className="root">
        {/* {shouldBadgeShow &&
          `+ ${displayLength} item${length != 1 ? "s" : ""} selected`} */}
      </div>
    </components.ValueContainer>
  );
};


const Relationship = () => {
  const [relationshipName, setRelationshipName] = useState('');
  const [description, setDescription] = useState('');
  const [process, setProcess] = useState({});
  const [relationshipType, setRelationshipType] = useState({});
  const [targetNames, setSelectedOptions] = useState([]);

  const [selectedprocess1, setSelectedprocess1] = useState([]);

  // Create state variable for the Select component's value
  const [selectedSource, setSelectedSource] = useState('');
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));

  const shouldBeShown = (value) => {
    return value.data.shouldShow;
  };

  const styles = {
    option: (base, value) => {
        return (shouldBeShown(value) ?  { display: 'none'} : { ...base } );
    }
};

  // Handle the change event for the Select component
  const handleSelectChange = (event, { value }) => {
    setSelectedSource(event);
  };

  const handleSelectChange1 = (event, { value }) => {
    setProcess(value);
    fetchsheetdata(event);
  };

  const handleSelectChange2 = (event, { value }) => {
    setRelationshipType(value);
  };


  const saveRelationship = () =>{
    
    let payload = {
        'relationship_name': relationshipName,
        'relationship_description': description,
        'process': process,
        'relationship_type': relationshipType,
        'sources': selectedSource
        
    }
    console.log('payload', payload)
    var FileUploadCredentials = SaveRelationship();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
            response => {
                console.log("Validate Credentials Response!!!", response);
                window.location.reload();
            }
        )
        .catch((error) => {
            console.error("Error in POST request:", error);
          });
  }



  const fetchsheetdata = (process1) => {
    let payload = {
      File_data: process1,
    }

    var FileUploadCredentials = SheetDatanew();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          console.log("Validate Credentials Response!!!", response);
          let table_data = response.data;
          console.log(table_data)
          let table_data_val = table_data;
          let names = [{ value: "", label: "Select Source" },]
          table_data.map((data) => {
            console.log('data' + data.source_name);

            let obj = {
              value: data.source_id,
              label: data.source_name
            }
            names.push(obj);
          })
          setSelectedOptions(names);
        }
      )
  };


  const fetchProcessNames = () => {

    let payload = {
        'tenants': userCredentials["tenants_id"],
        'groups': userCredentials["groups_id"],
        'entities': userCredentials["entities_id"],
        
    }

    var FileUploadCredentials = GetProcessNames();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
            response => {
                console.log("Validate Credentials Response!!!", response);
                let table_data = response.data;

                let names = [];
                table_data.map((data) => {

                    let obj = {
                        value: data.process_id,
                        label: data.process_name
                    }
                    names.push(obj);
                })
                setSelectedprocess1(names);
            }
        )
}

useEffect(() => {
  
  fetchProcessNames();
},[]);
  return (
    <>
      <Grid item style={{ backgroundColor: "#fff", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
        <div style={{ width: '100%' }}>
          <h2 className=" pt-1 pb-1 text-center" style={{ color: "#4969ab" }}>RELATIONSHIPS</h2>
        </div>
      </Grid>
      <Grid columns='equal' divided style={{ backgroundColor: "#fff", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
        <Grid.Row >
          <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`relationshipNameInput`}>Relationship name</label> <br />
              <div>
                <Input
                  type="text"
                  className="resource_input"
                  style={{ width: '12em' }}
                  placeholder="Relationship name"
                  value={relationshipName}
                  onChange={(e) => setRelationshipName(e.target.value)}
                />
              </div>
            </div>
          </Grid.Column>
          <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`descriptionInput`}>Description</label> <br />
              <div >
                <Input
                  type="text"
                  className="resource_input"
                  style={{ width: '12em' }}
                  placeholder="Description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
            </div>
          </Grid.Column>
          <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`processInput`}>Process</label> <br />
              <div >
                <Select
                  clearable
                  options={selectedprocess1}
                  selection
                  className="resource_input"
                  size='mini'
                  value={process}
                  onChange={handleSelectChange1}

                />
              </div>
            </div>
          </Grid.Column>
          <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`relationshipTypeInput`}>Relationship Type</label> <br />
              <Select
                clearable
                options={identifier1}
                selection
                className="resource_input"
                size='mini'
                value={relationshipType}
                onChange={handleSelectChange2}
              />
            </div>
          </Grid.Column>
          

        </Grid.Row>

      </Grid>
      <Grid columns='equal' divided style={{ backgroundColor: "#fff", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
      <Grid.Row >
      <Grid.Column></Grid.Column>
        <Grid.Column>
          <div className="form-group">
            <label className="label1 mb-1" htmlFor={`sourceInput`}>Sources</label> <br />
            <Select
              clearable
              options={targetNames}
              selection
              isMulti
              className="resource_input"
              size='mini'
              value={selectedSource}
              onChange={handleSelectChange}
              hideSelectedOptions={false}
              styles={styles}
              components={{ ValueContainer }}
            />
          </div>
          </Grid.Column>
          <Grid.Column>
          {selectedSource && (
            <table id="customers">
                
                {selectedSource.map((option) => (
                    <tr key={option.value}>
                    <th>{option.label}</th>
                    </tr>
                ))}

            </table>
            )}
          </Grid.Column>
          </Grid.Row>
      </Grid>
      <Grid columns='equal' divided style={{ backgroundColor: "#fff", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
        <Grid.Row >

          <Grid.Column>
            <button style={{ height: "35px", width: "92px", backgroundColor: "#000055", color: "#ffffff", marginLeft: '2em' }} onClick={saveRelationship}>Save</button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  )
}

export default Relationship;